import { z } from "zod";

export const userProfileSchema = z.object({
  name: z.string().min(2, "Nome deve ter pelo menos 2 caracteres"),
  email: z.string().email("Email inválido"),
  phone: z.string().optional(),
  roles: z.array(z.string()).min(1, "Selecione pelo menos um perfil"),
  company: z.string().optional(),
});

export type UserProfileFormData = z.infer<typeof userProfileSchema>;
